import React from 'react'
import "./index.css"

export default function Selector({ isSelected = false, onPress = () => { } }) {
  return (
    <span onClick={onPress} className={isSelected ? 'selector-active cursor' : 'selector-inactive cursor'} />
  )
}
